import { EnvironmentProviders, Provider } from '@angular/core';
import { FP_CORRELATION_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/providers/fp-correlation-tab-connect-services.token';
import { FpCorrelationSpectrumChartService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/services/fp-correlation-spectrum-chart.service';
import { FpCorrelationSpectrumConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/services/fp-correlation-spectrum-connect.service';
import { FpCorrelationSpectrumExportService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/services/fp-correlation-spectrum-export.service';
import { FpCorrelationSpectrumStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/services/fp-correlation-spectrum/fp-correlation-spectrum.store';

export function fpCorrelationSpectrumProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpCorrelationSpectrumChartService,
    FpCorrelationSpectrumExportService,
    FpCorrelationSpectrumStore,
    FpCorrelationSpectrumConnectService,
    {
      provide: FP_CORRELATION_TAB_CONNECT_SERVICES,
      useExisting: FpCorrelationSpectrumConnectService,
      multi: true,
    },
  ];
}
